import React from 'react';

import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';

import type { FavoriteButtonVariant } from '~/components/common/favorites/types';
import ShareButton from '~/components/common/ui/ShareButton/ShareButton';
import type { CouplesStorefrontDetails } from '~/types/storefrontDetails';
import { TrackingProductLocation } from '~/util/trackingHelper';

import { useStorefrontDetails } from '../contexts/StorefrontDetailsContext';
import FavoriteCTA from './favorites/FavoriteCTA';
import { Container } from './ShareOrFavorite.styles';

type ShareOrFavoriteProps = {
  className?: string;
  favoriteButtonVariant?: FavoriteButtonVariant;
  shareButtonVariant?: 'full' | 'compact';
};

const ShareOrFavorite = ({
  favoriteButtonVariant,
  shareButtonVariant,
  className,
}: ShareOrFavoriteProps) => {
  const { storefrontDetails } = useStorefrontDetails<CouplesStorefrontDetails>();
  const { name, coverGallery, location, taxonomyKey, uuid, slug } = storefrontDetails;

  const storefrontCoverUuid = coverGallery?.[0]?.uuid;

  return (
    <Container className={className}>
      <FavoriteCTA
        storefrontUuid={uuid}
        storefrontCoverUuid={storefrontCoverUuid}
        variant={favoriteButtonVariant}
      />
      <ShareButton
        uuid={uuid}
        trackingLocation={TrackingProductLocation.STOREFRONT_DETAIL_PAGE}
        businessUnit={BUSINESS_UNIT.MARKETPLACE}
        customCtaId="SHARE_VENDOR"
        variant={shareButtonVariant}
        buttonV3Variant="secondary"
        imageUuid={storefrontCoverUuid}
        modalType="vendors"
        modalHed=""
        name={name}
        location={location || ''}
        taxonomyKey={taxonomyKey}
        slug={slug}
      />
    </Container>
  );
};

export default ShareOrFavorite;
